export default "__VITE_ASSET__CAUkKsjj__"